import { FC, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { isLoggedInTemplate } from 'apollo/templates/user';
import { logout } from './utils/logout';

export const SessionWatcher: FC = () => {
    const { data, startPolling, stopPolling } = useQuery(isLoggedInTemplate, {
        pollInterval: 0, // don’t start immediately
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        // Start polling every 60 seconds
        startPolling(60_000);
        return () => stopPolling();
    }, [startPolling, stopPolling]);

    useEffect(() => {
        if (data && data.isLoggedIn === false) {
            logout(true);
        }
    }, [data]);

    return null; // This component doesn’t render anything
};
